import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SharedModule } from 'src/app/core/shared.module';
import { CargoRoutingModule } from './cargo-routing.module';
import { ManualCreationCargoComponent } from './manual-creation-cargo/manual-creation-cargo.component';
import { TypeTripComponent } from './manual-creation-cargo/components/type-trip/type-trip.component';
import { TypeRegimeComponent } from './manual-creation-cargo/components/type-regime/typeRegime.component';
import { TypeCargoComponent } from './manual-creation-cargo/components/type-cargo/type-cargo.component';
import { AssignVehicleCargoComponent } from './assign-vehicle-cargo/assign-vehicle-cargo.component';
import { CargoItemComponent } from './cargo-item/cargo-item.component';
import { AdditionalServiceComponent } from './additional-service/additional-service.component';
import { CalculatorMeasurementsComponent } from './manual-creation-cargo/components/calculator-measurements/calculatorMeasurements.component';
import { ContainerMeasureComponent } from './manual-creation-cargo/components/container-measure/containerMeasure.component';
import { DateCargoComponent } from './manual-creation-cargo/components/date-cargo/date-cargo.component';
import { DownloadComponent } from './manual-creation-cargo/components/download/download.component';
import { CargoValueComponent } from './manual-creation-cargo/components/cargo-value/cargo-value.component';
import { LoadMeasurementsComponent } from './manual-creation-cargo/components/load-measurements/load-measurements.component';
import { LocationsFreightComponent } from './manual-creation-cargo/components/cargo-locations/cargo-locations.component';
import { MethodPaymentComponent } from './manual-creation-cargo/components/method-payment/method-payment.component';
import { QuantityVehiclesComponent } from './manual-creation-cargo/components/quantity-vehicles/quantity-vehicles.component';
import { TotalValueComponent } from './manual-creation-cargo/components/total-value/totalValue.component';
import { TypeMerchandiseComponent } from './manual-creation-cargo/components/type-merchandise/type-merchandise.component';
import { TypeServiceComponent } from './manual-creation-cargo/components/type-service/type-service.component';
import { UploadDownloadMapComponent } from './manual-creation-cargo/components/upload-download-map/upload-download-map.component';
import { UploadComponent } from './manual-creation-cargo/components/upload/upload.component';
import { CargoDetailComponent } from './cargo-detail/cargo-detail.component';
import { CargoListComponent } from './cargo-list/cargo-list.component';
import { CargoCreateTabsComponent } from './cargo-tabs-create/cargo-tabs-create.component';
import { CargoTrackingComponent } from './cargo-tracking/cargo-tracking.component';
import { ListCargoPaymentsComponent } from './list-cargo-payments/list-cargo-payments.component';
import { RegisterCargoPaymentComponent } from './register-cargo-payment/register-cargo-payment.component';
import { MassCreationCargoComponent } from './mass-creation-cargo/mass-creation-cargo.component';
import { CreateCargoFromGuidesComponent } from '../guides/create-cargo-from-guides/create-cargo-from-guides.component';
import { ListCargoFromGuidesComponent } from '../guides/create-cargo-from-guides/list-cargo-from-guides/list-cargo-from-guides.component';
import { TripTypeDocumentsComponent } from './manual-creation-cargo/components/trip-type-documents/trip-type-documents.component';
import { CargoControlTrackingComponent } from './cargo-control-tracking/cargo-control-tracking.component';
import { CargoResources } from './manual-creation-cargo/resources/cargo';
import { UploadLocationComponent } from './manual-creation-cargo/components/upload-location/upload-location.component';
import { DownloadLocationComponent } from './manual-creation-cargo/components/download-location/download-location.component';
import { ThirdPartyConsignmentComponent } from './manual-creation-cargo/components/third-party-consignment/third-party-consignment.component';
import { FormThirdPartyConsignmentComponent } from './manual-creation-cargo/components/form-third-party-consignment/form-third-party-consignment.component';
import { UploadRouteComponent } from './upload-route/upload-route.component';
import { DiscountsAndBonusesCargoComponent } from './discounts-and-bonuses-cargo/discounts-and-bonuses-cargo.component';
import { AdditionalCostsHistoryComponent } from './additional-costs-history/additional-costs-history.component';
import { ExternalManifestCargoComponent } from './cargo-detail/components/external-manifest-cargo/external-manifest-cargo.component';
import { AssignLicensePlateComponent } from './manual-creation-cargo/components/assign-license-plate/assign-license-plate.component';
import { CargoOptionsComponent } from './cargo-options/cargo-options.component';
import { FreightListService } from './cargo-list/cargo-list.service';
import { ChangeCompanyComponent } from './change-company/change-company.component';
import { CargoReteicaComponent } from './cargo-reteica/cargo-reteica.component';
import { MonitoringCompanySelectorComponent } from './monitoring-company-selector/monitoring-company-selector.component';
import { CargoRenewDatesComponent } from './cargo-renew-dates/cargo-renew-dates.component';
import { CargoHistoryNewsComponent } from './cargo-history-news/cargo-history-news.component';
import { CargoSearchComponent } from './cargo-search/cargo-search.component';
import { CargoBillingComponent } from './cargo-billing/cargo-billing.component';
//import { ItemAdditionalServiceComponent } from './item-additional-service/item-additional-service.component';
//import { ListAdditionalServicesComponent } from './list-additional-services/list-additional-services.component';
import { CreationAdditionalCostCargoComponent } from './manual-creation-cargo/components/creation-additional-cost-cargo/creation-additional-cost-cargo.component';
import { UpdateAdditionalCostCargoComponent } from './cargo-detail/components/update-additional-cost-cargo/update-additional-cost-cargo.component';
import { CargoRatingComponent } from './cargo-rating/cargo-rating.component';
import { CargoUpdateComponent } from './cargo-update/cargo-update.component';
import { CargoPaymentsComponent } from './cargo-payments/cargo-payments.component';
import { CargoListPaymentsComponent } from './cargo-list-payments/cargo-list-payments.component';
import { CargoAdvancePercentageComponent } from './cargo-advance-percentage/cargo-advance-percentage.component';
import { BoxTypeTripComponent } from './manual-creation-cargo/components/box-type-trip/box-type-trip.component';
import { BoxTypeRegimeComponent } from './manual-creation-cargo/components/box-type-regime/box-type-regime.component';
//import { BoxTypeCargaComponent } from './manual-creation-cargo/components/box-type-carga/box-type-carga.component';
//import { CargoTypeMerchandiseComponent } from './cargo-type-merchandise/cargo-type-merchandisecomponent';
import { BoxTypeServiceComponent } from './manual-creation-cargo/components/box-type-service/box-type-service.component';
import { BoxContainerMeasureComponent } from './manual-creation-cargo/components/box-container-measure/box-container-measure.component';
import { DriverSummaryComponent } from './driver-summary/driver-summary.component';
import { VehicleLiveStatusComponent } from './vehicle-live-status/vehicle-live-status.component';
import { CargoListTurnComponent } from './cargo-list-turn/cargo-list-turn.component';
import { CargoItemTurnComponent } from './cargo-item-turn/cargo-item-turn.component';
import { turnFilterComponent } from './turn-filter/turn-filter.component';
import { SummaryAdditionalCostCargoComponent } from './summary-additional-cost-cargo/summary-additional-cost-cargo.component';
import { EmailFormComponent } from './email-form/email-form.component';
import { CargoTurnFormComponent } from './cargo-turn-form/cargo-turn-form.component';
import { CargoEditTypeVehicleComponent } from './cargo-edit-type-vehicle/cargo-edit-type-vehicle.component';
import { CargoTrackingStatesHistoryComponent } from './cargo-tracking-states-history/cargo-tracking-states-history.component';
import { CargoLocationReportComponent } from './cargo-location-report/cargo-location-report.component';
import { CargoLastPointLocationComponent } from './cargo-last-point-location/cargo-last-point-location.component';
import { SummaryAnomalyCargoTrackingComponent } from './summary-anomaly-cargo-tracking/summary-anomaly-cargo-tracking.component';
import { SummaryAnomalyItemCargoTrackingComponent } from './summary-anomaly-item-cargo-tracking/summary-anomaly-item-cargo-tracking.component';
import { BellAlertComponent } from './bell-alert/bell-alert.component';
import { BoxSealComponent } from './manual-creation-cargo/components/box-seal/box-seal.component';
import { CargoValidators } from 'src/app/core/validators/cargo.validators';
import { MapTrackingComponent } from './map-tracking/map-tracking.component';
import { GlobalTrackingComponent } from './global-tracking/global-tracking.component';
import { GlobalTrackingListComponent } from './global-tracking-list/global-tracking-list.component';
import { InputValidators } from 'src/app/core/validators/input.validators';
import { CreateDiscountsAndBonusesComponent } from './create-discounts-and-bonuses/create-discounts-and-bonuses.component';
import { BranchOfficeOwnerCargoComponent } from './branch-office-owner-cargo/branch-office-owner-cargo.component';
import { RoundedCargoComponent } from './rounded-cargo/rounded-cargo.component';
import { confirmDeleteComponent } from './confirm-delete/confirm-delete.component';
import { ConfirmBellAlertsComponent } from './confirm-bell-alerts/confirm-bell-alerts.component';
import { CargoTabsLoadingRoutesComponent } from './cargo-tabs-loading-routes/cargo-tabs-loading-routes.component';
import { OpenDetailManifestsComponent } from './open-detail-manifests/open-detail-manifests.component';
import { CargoRequestAdvanceComponent } from './cargo-request-advance/cargo-request-advance.component';
import { ContainerChecklistComponent } from './container-checklist/container-checklist.component';
import { RateCostAdditionalServicesComponent } from './rate-cost-additional-services/rate-cost-additional-services.component';
import { ModalCargoUncaredComponent } from './modal-cargo-uncared/modal-cargo-uncared.component';
import { AvaliableCargoListComponent } from './avaliable-cargo-list/avaliable-cargo-list.component';
import { SummaryBalanceComponent } from './summary-balance/summary-balance.component';
import { ConventionsComponent } from 'src/app/shared/conventions/conventions.component';
import { ChangeDriverComponent } from './change-driver/change-driver.component';
import { RequestButtonComponent } from './manual-creation-cargo/components/request-button/request-button.component';
import { CargoGenerateFilterComponent } from './cargo-generate-filter/cargo-generate-filter.component';
import { CargoGenerateComponent } from './cargo-generate/cargo-generate.component';
import { CargoListExpensesIncomeComponent } from './cargo-list-expenses-income/cargo-list-expenses-income.component';
import { ResponseGenerateJournalComponent } from './response-generate-journal/response-generate-journal.component';
import { CreateCargoComponent } from './create-cargo/create-cargo.component';
import { CargoShippingCostDialogComponent } from './cargo-shipping-cost-dialog/cargo-shipping-cost-dialog.component';
import { TransferredPaymentsDialogComponent } from './transferred-payments-dialog/transferred-payments-dialog.component';
import { TimeToUploadEvidencesComponent } from './time-to-upload-evidences/time-to-upload-evidences.component';
import { CargoBillingXmlComponent } from './cargo-billing-xml/cargo-billing-xml.component';
import { CargoCashReceiptsComponent } from './cargo-cash-receipts/cargo-cash-receipts.component';
import { CargoCreditNoteAssociationComponent } from './cargo-credit-note-association/cargo-credit-note-association.component';
import { CargoCreditNoteAssociationSummaryComponent } from './cargo-credit-note-association-summary/cargo-credit-note-association-summary.component';
import { CargoDriverDocumentidDialogComponent } from './cargo-driver-documentid-dialog/cargo-driver-documentid-dialog.component';
import { EndCargoCheckComponent } from './end-cargo-check/end-cargo-check.component';
import { RequestDatesToMonitorComponent } from './request-dates-to-monitor/request-dates-to-monitor.component';
import { MoveAdvanceDialogComponent } from './move-advance-dialog/move-advance-dialog.component';
import { DatePipe } from '@angular/common';
import { CompanyNamePipe } from 'src/app/core/pipe/companyName.pipe';
import { MassivePaymentsComponent } from './massive-payments/massive-payments.component';
import { ListMassivePaymentsLoadsComponent } from './list-massive-payments-loads/list-massive-payments-loads.component';
import { AlertAdvancePaymentComponent } from './alert-advance-payment/alert-advance-payment.component';
import { CargoComplimentsComponent } from './cargo-compliments/cargo-compliments.component';
import { TravelExpensesComponent } from './manual-creation-cargo/travel-expenses/travel-expenses.component';
import { ReactiveFormsModule } from '@angular/forms';
import { LegalizeTravelExpensesComponent } from './legalize-travel-expenses/legalize-travel-expenses.component';
import { FormTravelExpenseDetailComponent } from './form-travel-expense-detail/form-travel-expense-detail.component';
import { TravelExpensesDetailComponent } from './travel-expenses-detail/travel-expenses-detail.component';
import { GeneralTableLegalizationTravelExpensesComponent } from './general-table-legalization-travel-expenses/general-table-legalization-travel-expenses.component';
import { CargoListServiceRequestsComponent } from './cargo-list-service-requests/cargo-list-service-requests.component';
import { ListTransportRequestsComponent } from './list-transport-requests/list-transport-requests.component';
import { VehicleApplicationsTransportRequestsComponent } from './vehicle-applications-transport-requests/vehicle-applications-transport-requests.component';
import { ServiceRequestsItemComponent } from './service-requests-item/service-requests-item.component';
import { ServiceRequestsTabsComponent } from './service-requests-tabs/service-requests-tabs.component';
import { DriverEscortedVehicleComponent } from './driver-escorted-vehicle/driver-escorted-vehicle.component';
import { CreateEscortServiceComponent } from './create-escort-service/create-escort-service.component';
import { CreateSatelliteLockServiceComponent } from './create-satellite-lock-service/create-satellite-lock-service.component';
import { ConsignmentFormComponent } from './consignment-form/consignment-form.component';
import { TripTypeFieldComponent } from './fields-form/trip-type-field/trip-type-field.component';
import { CargoTypeFieldComponent } from './fields-form/cargo-type-field/cargo-type-field.component';
import { ServiceTypeFieldComponent } from './fields-form/service-type-field/service-type-field.component';
import { PackagingTypeFieldComponent } from './fields-form/packaging-type-field/packaging-type-field.component';
import { ProductTypeFieldComponent } from './fields-form/product-type-field/product-type-field.component';
import { VehicleTypeFieldComponent } from './fields-form/vehicle-type-field/vehicle-type-field.component';
import { BodyworkTypeFieldComponent } from './fields-form/bodywork-type-field/bodywork-type-field.component';
import { OriginUploadFieldComponent } from './fields-form/origin-upload-field/origin-upload-field.component';
import { DestinationDownloadFieldComponent } from './fields-form/destination-download-field/destination-download-field.component';
import { ListDownloadDestinationsFieldComponent } from './fields-form/list-download-destinations-field/list-download-destinations-field.component';
import { ThirdPartyConsignmentFieldComponent } from './fields-form/third-party-consignment-field/third-party-consignment-field.component';
import { DateFieldComponent } from './fields-form/date-field/date-field.component';
import { ListHoursFieldComponent } from './fields-form/list-hours-field/list-hours-field.component';
import { ListMinutesFieldComponent } from './fields-form/list-minutes-field/list-minutes-field.component';
import { TimeFieldComponent } from './fields-form/time-field/time-field.component';
import { AddressThirdPartyConsignmentFieldComponent } from './fields-form/address-third-party-consignment-field/address-third-party-consignment-field.component';
import { CargoPlanningRouteComponent } from './cargo-planning-route/cargo-planning-route.component';
import { MassiveCargoOperationComponent } from './massive-cargo-operation/massive-cargo-operation.component';
import { CargoOperationByPlateComponent } from './cargo-operation-by-plate/cargo-operation-by-plate.component';
import { CargoCreationModalComponent } from './cargo-creation-modal/cargo-creation-modal.component';
import { LinkServicesComponent } from './link-services/link-services.component';
import { ReplicateServiceComponent } from './replicate-service/replicate-service.component';
import { CargoValidationModalComponent } from './cargo-validation-modal/cargo-validation-modal.component';
import { PanelAssignmentComponent } from './panel-assignment/panel-assignment.component';
import { PanelAssignmentService } from './panel-assignment/panel-assignment.service';
import { ChangeDispatchStateDialogComponent } from './panel-assignment/change-dispatch-state-dialog/change-dispatch-state-dialog.component';
import { AssignSatelliteLockComponent } from './assign-satellite-lock/assign-satellite-lock.component';
import { CreateVehicleApplicationDialogComponent } from './vehicle-applications-transport-requests/create-vehicle-application-dialog/create-vehicle-application-dialog.component';
import { CargoPrevalidationComponent } from './cargo-prevalidation/cargo-prevalidation.component';
import { PreBillListComponent } from './pre-bill-list/pre-bill-list.component';
import { PreBillFormComponent } from './pre-bill-form/pre-bill-form.component';


@NgModule({
  imports: [
    SharedModule.forRoot(),
    CargoRoutingModule,
    ReactiveFormsModule
  ],
  declarations: [
    ManualCreationCargoComponent,
    TypeTripComponent,
    TypeRegimeComponent,
    TypeCargoComponent,
    ContainerMeasureComponent,
    TypeServiceComponent,
    TypeMerchandiseComponent,
    QuantityVehiclesComponent,
    LoadMeasurementsComponent,
    UploadComponent,
    UploadDownloadMapComponent,
    DownloadComponent,
    DateCargoComponent,
    DateCargoComponent,
    AdditionalServiceComponent,
    CargoValueComponent,
    MethodPaymentComponent,
    TotalValueComponent,
    CalculatorMeasurementsComponent,
    CargoTrackingComponent,
    CargoListComponent,
    CargoItemComponent,
    CargoListTurnComponent,
    CargoItemTurnComponent,
    CargoTurnFormComponent,
    LocationsFreightComponent,
    CargoCreateTabsComponent,
    turnFilterComponent,
    CargoUpdateComponent,
    CargoDetailComponent,
    CargoPlanningRouteComponent,
    RegisterCargoPaymentComponent,
    AssignVehicleCargoComponent,
    ListCargoPaymentsComponent,
    MassCreationCargoComponent,
    CreateCargoFromGuidesComponent,
    ListCargoFromGuidesComponent,
    TripTypeDocumentsComponent,
    CargoControlTrackingComponent,
    UploadLocationComponent,
    DownloadLocationComponent,
    ThirdPartyConsignmentComponent,
    FormThirdPartyConsignmentComponent,
    UploadRouteComponent,
    //BoxTypeCargaComponent,
    BoxTypeTripComponent,
    BoxSealComponent,
    BoxTypeServiceComponent,
    BoxTypeRegimeComponent,
    BoxContainerMeasureComponent,
    DiscountsAndBonusesCargoComponent,
    AdditionalCostsHistoryComponent,
    ExternalManifestCargoComponent,
    AssignLicensePlateComponent,
    CargoOptionsComponent,
    ChangeCompanyComponent,
    MonitoringCompanySelectorComponent,
    CargoReteicaComponent,
    CargoRenewDatesComponent,
    CargoHistoryNewsComponent,
    CargoSearchComponent,
    CargoBillingComponent,
    ResponseGenerateJournalComponent,
    //ItemAdditionalServiceComponent,
    //ListAdditionalServicesComponent,
    CreationAdditionalCostCargoComponent,
    UpdateAdditionalCostCargoComponent,
    CargoRatingComponent,
    CargoEditTypeVehicleComponent,
    CargoPaymentsComponent,
    CargoListPaymentsComponent,
    CargoAdvancePercentageComponent,
    //CargoTypeMerchandiseComponent,
    DriverSummaryComponent,
    VehicleLiveStatusComponent,
    SummaryAdditionalCostCargoComponent,
    EmailFormComponent,
    CargoGenerateComponent,
    CargoGenerateFilterComponent,
    CargoListExpensesIncomeComponent,
    CargoTrackingStatesHistoryComponent,
    CargoLocationReportComponent,
    CargoLastPointLocationComponent,
    SummaryAnomalyCargoTrackingComponent,
    SummaryAnomalyItemCargoTrackingComponent,
    BellAlertComponent,
    MapTrackingComponent,
    GlobalTrackingComponent,
    GlobalTrackingListComponent,
    CreateDiscountsAndBonusesComponent,
    BranchOfficeOwnerCargoComponent,
    RoundedCargoComponent,
    LinkServicesComponent,
    ReplicateServiceComponent,
    confirmDeleteComponent,
    ConfirmBellAlertsComponent,
    CargoTabsLoadingRoutesComponent,
    OpenDetailManifestsComponent,
    CargoRequestAdvanceComponent,
    ContainerChecklistComponent,
    RateCostAdditionalServicesComponent,
    ModalCargoUncaredComponent,
    AvaliableCargoListComponent,
    SummaryBalanceComponent,
    ChangeDriverComponent,
    RequestButtonComponent,
    CreateCargoComponent,
    CargoShippingCostDialogComponent,
    TransferredPaymentsDialogComponent,
    TimeToUploadEvidencesComponent,
    CargoBillingXmlComponent,
    CargoCashReceiptsComponent,
    CargoCreditNoteAssociationComponent,
    CargoCreditNoteAssociationSummaryComponent,
    CargoDriverDocumentidDialogComponent,
    EndCargoCheckComponent,
    RequestDatesToMonitorComponent,
    MoveAdvanceDialogComponent,
    MassivePaymentsComponent,
    MassiveCargoOperationComponent,
    CargoOperationByPlateComponent,
    ListMassivePaymentsLoadsComponent,
    AlertAdvancePaymentComponent,
    CargoComplimentsComponent,
    TravelExpensesComponent,
    LegalizeTravelExpensesComponent,
    FormTravelExpenseDetailComponent,
    TravelExpensesDetailComponent,
    GeneralTableLegalizationTravelExpensesComponent,
    CargoListServiceRequestsComponent,
    ListTransportRequestsComponent,
    VehicleApplicationsTransportRequestsComponent,
    ServiceRequestsItemComponent,
    ServiceRequestsTabsComponent,
    DriverEscortedVehicleComponent,
    CreateEscortServiceComponent,
    CreateSatelliteLockServiceComponent,
    ConsignmentFormComponent,
    TripTypeFieldComponent,
    CargoTypeFieldComponent,
    ServiceTypeFieldComponent,
    PackagingTypeFieldComponent,
    ProductTypeFieldComponent,
    VehicleTypeFieldComponent,
    BodyworkTypeFieldComponent,
    OriginUploadFieldComponent,
    DestinationDownloadFieldComponent,
    ListDownloadDestinationsFieldComponent,
    ThirdPartyConsignmentFieldComponent,
    DateFieldComponent,
    ListHoursFieldComponent,
    ListMinutesFieldComponent,
    TimeFieldComponent,
    AddressThirdPartyConsignmentFieldComponent,
    CargoPlanningRouteComponent,
    CargoCreationModalComponent,
    CargoValidationModalComponent,
    PanelAssignmentComponent,
    ChangeDispatchStateDialogComponent,
    AssignSatelliteLockComponent,
    CreateVehicleApplicationDialogComponent,
    CargoPrevalidationComponent,
    PreBillListComponent,
    PreBillFormComponent,
  ],
  entryComponents: [
    PreBillFormComponent,
    CalculatorMeasurementsComponent,
    FormThirdPartyConsignmentComponent,
    AdditionalCostsHistoryComponent,
    DiscountsAndBonusesCargoComponent,
    ExternalManifestCargoComponent,
    CargoReteicaComponent,
    CargoRenewDatesComponent,
    RoundedCargoComponent,
    LinkServicesComponent,
    ReplicateServiceComponent,
    ChangeCompanyComponent,
    CargoReteicaComponent,
    CargoHistoryNewsComponent,
    CargoBillingComponent,
    CargoBillingXmlComponent,
    CargoCashReceiptsComponent,
    CargoCreditNoteAssociationComponent,
    CargoCreditNoteAssociationSummaryComponent,
    ResponseGenerateJournalComponent,
    CargoRatingComponent,
    CargoUpdateComponent,
    AdditionalServiceComponent,
    CargoEditTypeVehicleComponent,
    UpdateAdditionalCostCargoComponent,
    ConventionsComponent,
    CargoAdvancePercentageComponent,
    SummaryAdditionalCostCargoComponent,
    CargoTurnFormComponent,
    EmailFormComponent,
    CargoLocationReportComponent,
    CreateDiscountsAndBonusesComponent,
    OpenDetailManifestsComponent,
    CargoRequestAdvanceComponent,
    ContainerChecklistComponent,
    confirmDeleteComponent,
    ConfirmBellAlertsComponent,
    OpenDetailManifestsComponent,
    RateCostAdditionalServicesComponent,
    ModalCargoUncaredComponent,
    AssignVehicleCargoComponent,
    AvaliableCargoListComponent,
    SummaryBalanceComponent,
    ChangeDriverComponent,
    CargoShippingCostDialogComponent,
    TransferredPaymentsDialogComponent,
    TimeToUploadEvidencesComponent,
    CargoDriverDocumentidDialogComponent,
    EndCargoCheckComponent,
    RequestDatesToMonitorComponent,
    MoveAdvanceDialogComponent,
    MassivePaymentsComponent,
    MassiveCargoOperationComponent,
    CargoOperationByPlateComponent,
    AlertAdvancePaymentComponent,
    CargoComplimentsComponent,
    TravelExpensesComponent,
    LegalizeTravelExpensesComponent,
    FormTravelExpenseDetailComponent,
    TravelExpensesDetailComponent,
    GeneralTableLegalizationTravelExpensesComponent,
    CargoPlanningRouteComponent,
    ConsignmentFormComponent,
    CargoCreationModalComponent,
    CargoValidationModalComponent,
    CargoGenerateFilterComponent,
    CargoOptionsComponent,
    ChangeDispatchStateDialogComponent,
    AssignSatelliteLockComponent,
    CreateVehicleApplicationDialogComponent,
  ],
  exports: [
    ManualCreationCargoComponent,
    TypeTripComponent,
    TypeRegimeComponent,
    TypeCargoComponent,
    ContainerMeasureComponent,
    TypeServiceComponent,
    TypeMerchandiseComponent,
    QuantityVehiclesComponent,
    LoadMeasurementsComponent,
    UploadComponent,
    UploadDownloadMapComponent,
    DownloadComponent,
    DateCargoComponent,
    DateCargoComponent,
    AdditionalServiceComponent,
    CargoValueComponent,
    MethodPaymentComponent,
    TotalValueComponent,
    CalculatorMeasurementsComponent,
    CargoTrackingComponent,
    CargoListComponent,
    CargoItemComponent,
    CargoListTurnComponent,
    CargoItemTurnComponent,
    LocationsFreightComponent,
    CargoCreateTabsComponent,
    CargoUpdateComponent,
    turnFilterComponent,
    CargoDetailComponent,
    CargoPlanningRouteComponent,
    RegisterCargoPaymentComponent,
    ListCargoPaymentsComponent,
    TripTypeDocumentsComponent,
    CargoControlTrackingComponent,
    UploadLocationComponent,
    DownloadLocationComponent,
    ThirdPartyConsignmentComponent,
    FormThirdPartyConsignmentComponent,
    UploadRouteComponent,
    BoxTypeTripComponent,
    BoxSealComponent,
    BoxTypeServiceComponent,
    BoxTypeRegimeComponent,
    ConfirmBellAlertsComponent,
    //BoxTypeCargaComponent,
    BoxContainerMeasureComponent,
    DiscountsAndBonusesCargoComponent,
    AdditionalCostsHistoryComponent,
    CreateDiscountsAndBonusesComponent,
    ExternalManifestCargoComponent,
    CargoReteicaComponent,
    CargoRenewDatesComponent,
    RoundedCargoComponent,
    LinkServicesComponent,
    ReplicateServiceComponent,
    ChangeCompanyComponent,
    MonitoringCompanySelectorComponent,
    CargoReteicaComponent,
    CargoHistoryNewsComponent,
    CargoRatingComponent,
    EmailFormComponent,
    CargoCreationModalComponent,
    CargoValidationModalComponent,
    CargoOptionsComponent,
    AssignSatelliteLockComponent,
  ],
  providers: [
    CargoResources,
    FreightListService,
    CargoValidators,
    InputValidators,
    DatePipe,
    CompanyNamePipe,
    PanelAssignmentService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class CargoModule {

}
